import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content", "expand"];
  static values = { height: Number, on: String, off: String };

  connect() {
    if (!this.hasHeightValue) this.heightValue = 100;
    if (!this.hasOnValue) this.onValue = "Развернуть";
    if (!this.hasOffValue) this.offValue = "Свернуть";

    this.expanded = false;
    this.apply();
  }

  toggle() {
    this.expanded = !this.expanded;
    this.apply();
  }

  apply() {
    if (this.hasContentTarget) {
      this.contentTarget.style.maxHeight = this.expanded
        ? "none"
        : `${this.heightValue}px`;
      this.contentTarget.style.overflow = this.expanded ? "visible" : "hidden";
    }

    if (this.hasExpandTarget) {
      this.expandTarget.textContent = this.expanded
        ? this.offValue
        : this.onValue;
    }
  }
}
